import styled, { css } from 'styled-components';

const BaseToastBannerCss = css`
  position: relative;
  display: flex;
  flex-direction: row;
  background-color: ${props => props.theme.colors.capsuleBlue50};
  border: none;
  &:focus {
    box-shadow: none;
  }
  cursor: pointer;
  height: 4.8rem;
  border-width: 0.1rem;
  border-radius: 0.3rem;

  margin: 0 0 4rem;
  width: 100%;
  ${props =>
    props.medicationsHomepageHack &&
    css`
      margin: 0 0 0 0.4rem;
      width: calc(100% - 0.8rem);
    `}

  ${props => props.theme.mediaQueries.smallDown} {
    margin: ${props => (props.medicationsHomepageHack ? '0 2.4rem 7rem' : '0 2rem 9.2rem')};
    width: ${props => (props.medicationsHomepageHack ? `calc(100% - 4.8rem)` : `calc(100% - 4rem)`)};
  } ;
`;
const BaseToastBannerButton = styled.button<{ medicationsHomepageHack: boolean }>`
  ${BaseToastBannerCss}
`;

export const RefillRequestedToastVariant = styled.div`
  ${BaseToastBannerCss}
  justify-content: space-between;
  align-items: center;
  padding: 1.4rem 2.4rem;
  margin: 0;
  width: unset;
`;

export const ViewOrderToastVariant = styled(props => <BaseToastBannerButton {...props} />)`
  justify-content: center;
  align-items: center;
`;

export const ToggleArchiveToastVariant = styled(props => <BaseToastBannerButton {...props} />)`
  justify-content: flex-start;
  align-items: center;
  padding: 2.4rem;
`;

export const OutlinedVariant = styled.div`
  ${BaseToastBannerCss}
  justify-content: center;
  align-items: center;
  padding: 1.4rem 2.4rem;
  margin: 0;
  font-size: ${props => props.theme.fontSizes.calloutSmall};
  width: unset;
  background-color: white;
  border: 1px solid;
  border-color: ${props => props.theme.colors.capsuleBlue50};

  ${props => props.theme.mediaQueries.smallDown} {
    margin: 0 2rem 4rem;
  } ;
`;

export const TrailingTransparentGradient = styled.div`
  background: linear-gradient(
    180deg,
    rgba(239, 245, 245, 0) 0%,
    rgba(239, 245, 245, 0.4) 15.63%,
    rgba(239, 245, 245, 0.8) 100%
  );
  height: 2.4rem;
  width: 100%;
  margin-top: -0.1rem;
`;
